import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { filter, map, takeUntil } from "rxjs/operators";

@Component({
  selector: 'gen-release-report-preview',
  templateUrl: './release-report.component.html',
  styleUrls: ['./release-report.component.scss']
})

export class ReleaseReportComponent implements OnInit, OnDestroy {
  private tunnel$: Subject<any>;
  private destroyed$: Subject<any> = new Subject();

  public message: string;
  public payload: {
    text: string
  };
  public callback: (summaryText: string) => void;

  ngOnInit() {
    this.tunnel$
      .asObservable()
      .pipe(
        filter(message => message.emitter != 'children' && message.value),
        map(message => message.value),
        takeUntil(this.destroyed$.asObservable())
      )
      .subscribe(() => {
        this.callback(this.payload.text);
        this.tunnel$.next({ emitter: 'children', value: 1 });
      });
  }

  updateSummaryText(text) {
    this.payload.text = text.target.value;
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}

